import request from '@/utils/request'

// 社区公告
export const communityAnnoPage = (data = {}) => request({ url: `/api/community/v1/community/communityAnnoPage`, method: 'post', data })

export const communityAnnoCount = (data = {}) => request({ url: `/api/community/v1/community/communityAnnoCount`, method: 'post', data })

export const communityContentIns = (data = {}) => request({ url: `/api/community/v1/community/communityContentIns`, method: 'post', data })

export const communityAnnoUpd = (data = {}) => request({ url: `/api/community/v1/community/communityAnnoUpd`, method: 'post', data })

export const contentUnReadList = (data = {}) => request({ url: `/api/community/v1/community/contentUnReadList`, method: 'post', data })

export const unReadContentRemind = (data = {}) => request({ url: `/api/community/v1/community/unReadContentRemind`, method: 'post', data })

export const contentManageDetail = (data = {}) => request({ url: `/api/community/v1/community/contentManageDetail`, method: 'post', data })

export const cancelTopContent = (data = {}) => request({ url: `/api/community/v1/community/cancelTopContent`, method: 'post', data })

export const setTopContent = (data = {}) => request({ url: `/api/community/v1/community/setTopContent`, method: 'post', data })

// 内部通知
export const companyNoticePage = (data = {}) => request({ url: `/api/estate/v1/community/companyNoticePage`, method: 'post', data })

export const companyNoticeCount = (data = {}) => request({ url: `/api/estate/v1/community/companyNoticeCount`, method: 'post', data })

export const contentCompanyNoticeUnReadPage = (data = {}) => request({ url: `/api/estate/v1/community/contentCompanyNoticeUnReadPage`, method: 'post', data })

export const companyNoticeIns = (data = {}) => request({ url: `/api/estate/v1/community/companyNoticeIns`, method: 'post', data })

export const companyNoticeUpd = (data = {}) => request({ url: `/api/estate/v1/community/companyNoticeUpd`, method: 'post', data })

export const companyNoticeDetail = (data = {}) => request({ url: `/api/estate/v1/community/companyNoticeDetail`, method: 'post', data })

export const setTopCompanyNotice = (data = {}) => request({ url: `/api/estate/v1/community/setTopCompanyNotice`, method: 'post', data })

export const cancelTopCompanyNotice = (data = {}) => request({ url: `/api/estate/v1/community/cancelTopCompanyNotice`, method: 'post', data })

export const companyNoticeDel = (data = {}) => request({ url: `/api/estate/v1/community/companyNoticeDel`, method: 'post', data })

// 物业风采
export const workReportCustomPage = (data = {}) => request({ url: `/api/estate/v1/community/workReportCustomPage`, method: 'post', data })

export const workReportDel = (data = {}) => request({ url: `/api/estate/v1/community/workReportDel`, method: 'post', data })

export const workReportCustomUpsert = (data = {}) => request({ url: `/api/estate/v1/community/workReportCustomUpsert`, method: 'post', data })

// 项目管理
export const communityPage = (data = {}) => request({ url: `/api/uc/v1/community/communityPage`, method: 'post', data })

export const communityCount = (data = {}) => request({ url: `/api/uc/v1/community/communityCount`, method: 'post', data })

export const communityDetail = (data = {}) => request({ url: `/api/uc/v1/community/communityDetail`, method: 'post', data })

//项目管理通行规则详情
export const accessControlConfigDetail = (data = {}) => request({ url: `/api/estate/v1/iot/accessControlConfigDetail`, method: 'post', data })
//项目管理通行规则配置
export const accessControlConfig = (data = {}) => request({ url: `/api/estate/v1/iot/accessControlConfig`, method: 'post', data })
// 部门管理
export const departmentPage = (data = {}) => request({ url: `/api/estate/v1/oa/departmentPage`, method: 'post', data })

export const departmentCount = (data = {}) => request({ url: `/api/estate/v1/oa/departmentCount`, method: 'post', data })

export const departmentIns = (data = {}) => request({ url: `/api/estate/v1/oa/departmentIns`, method: 'post', data })

export const departmentUpd = (data = {}) => request({ url: `/api/estate/v1/oa/departmentUpd`, method: 'post', data })

export const departmentDel = (data = {}) => request({ url: `/api/estate/v1/oa/departmentDel`, method: 'post', data })

export const departmentDelBatch = (data = {}) => request({ url: `/api/estate/v1/oa/departmentDelBatch`, method: 'post', data })

export const departmentStaffList = (data = {}) => request({ url: `/api/estate/v1/oa/departmentStaffList`, method: 'post', data })

export const departmentDetail = (data = {}) => request({ url: `/api/estate/v1/oa/departmentDetail`, method: 'post', data })

// 角色管理
export const rolePage = (data = {}) => request({ url: `/api/estate/v1/oa/rolePage`, method: 'post', data })

export const roleCount = (data = {}) => request({ url: `/api/estate/v1/oa/roleCount`, method: 'post', data })

export const roleIns = (data = {}) => request({ url: `/api/estate/v1/oa/roleIns`, method: 'post', data })

export const roleDel = (data = {}) => request({ url: `/api/estate/v1/oa/roleDel`, method: 'post', data })

export const roleUpd = (data = {}) => request({ url: `/api/estate/v1/oa/roleUpd`, method: 'post', data })

// 人员管理
export const getPayTypByCommunityId = (data = {}) => request({ url: `/api/estate/v1/finance/getPayTypByCommunityId`, method: 'post', data })

export const getPermissionOrganizationIds = (data = {}) => request({ url: `/api/estate/v1/oa/getPermissionOrganizationIds`, method: 'post', data })

export const staffInfoPage = (data = {}) => request({ url: `/api/estate/v1/oa/staffInfoPage`, method: 'post', data })

export const staffInfoCount = (data = {}) => request({ url: `/api/estate/v1/oa/staffInfoCount`, method: 'post', data })

export const staffInfoIns = (data = {}) => request({ url: `/api/estate/v1/oa/staffInfoIns`, method: 'post', data })

export const staffInfoUpd = (data = {}) => request({ url: `/api/estate/v1/oa/staffInfoUpd`, method: 'post', data })

export const staffInfoDel = (data = {}) => request({ url: `/api/estate/v1/oa/staffInfoDel`, method: 'post', data })

export const staffInfoDetail = (data = {}) => request({ url: `/api/estate/v1/oa/staffInfoDetail`, method: 'post', data })

export const setUserRelCommunity = (data = {}) => request({ url: `/api/estate/v1/oa/setUserRelCommunity`, method: 'post', data })

export const accessControlStaffCardDetail = (data = {}) => request({ url: `/api/estate/v1/iot/accessControlStaffCardDetail`, method: 'post', data })

export const accessControlStaffCardIns = (data = {}) => request({ url: `/api/estate/v1/iot/accessControlStaffCardIns`, method: 'post', data })

export const streetPermissionConfigDropList = (data = {}) => request({ url: `/api/uc/v1/dropList/streetPermissionConfigDropList`, method: 'post', data })

export const dataPermissionConfigDropList = (data = {}) => request({ url: `/api/estate/v1/oa/dataPermissionConfigDropList`, method: 'post', data })

// 岗位级别档次列表
export const postRankGradePage = (data = {}) => request({ url: `/api/estate/v1/oa/postRankGradePage`, method: 'post', data })

export const postRankGradeCount = (data = {}) => request({ url: `/api/estate/v1/oa/postRankGradeCount`, method: 'post', data })

// 岗位级别列表
export const postRankPage = (data = {}) => request({ url: `/api/estate/v1/oa/postRankPage`, method: 'post', data })

export const postRankCount = (data = {}) => request({ url: `/api/estate/v1/oa/postRankCount`, method: 'post', data })

//岗位职级新增
export const postRankIns = (data = {}) => request({ url: `/api/estate/v1/oa/postRankIns`, method: 'post', data })
//岗位职级修改
export const postRankUpd = (data = {}) => request({ url: `/api/estate/v1/oa/postRankUpd`, method: 'post', data })
//岗位职级删除
export const postRankDel = (data = {}) => request({ url: `/api/estate/v1/oa/postRankDel`, method: 'post', data })

// 住户认证

export const holdAuthInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/holdAuthInfo`, method: 'post', data })

//住户管理-住户认证
export const webHoldAuthPage = (data = {}) => request({ url: `/api/estate/v1/workflow/webHoldAuthPage`, method: 'post', data })

export const webHoldAuthCount = (data = {}) => request({ url: `/api/estate/v1/workflow/webHoldAuthCount`, method: 'post', data })

// 审批流
export const flowConfigOverviewPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigOverviewPage`, method: 'post', data })

export const flowConfigOverviewCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigOverviewCount`, method: 'post', data })

export const flowConfigOverviewIns = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigOverviewIns`, method: 'post', data })

export const flowConfigOverviewUpd = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigOverviewUpd`, method: 'post', data })

export const flowConfigOverviewDelBatch = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigOverviewDelBatch`, method: 'post', data })

export const flowConfigOverviewDel = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigOverviewDel`, method: 'post', data })

export const flowConfigOverviewDetail = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigOverviewDetail`, method: 'post', data })

export const flowConfigStepDel = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigStepDel`, method: 'post', data })

export const flowConfigStepDelBatch = (data = {}) => request({ url: `/api/estate/v1/workflow/flowConfigStepDelBatch`, method: 'post', data })

// 请假类型
export const vacationTypePage = (data = {}) => request({ url: `/api/estate/v1/workflow/vacationTypePage`, method: 'post', data })

export const vacationTypeDel = (data = {}) => request({ url: `/api/estate/v1/workflow/vacationTypeDel`, method: 'post', data })

export const vacationTypeCount = (data = {}) => request({ url: `/api/estate/v1/workflow/vacationTypeCount`, method: 'post', data })

export const vacationTypeIns = (data = {}) => request({ url: `/api/estate/v1/workflow/vacationTypeIns`, method: 'post', data })

export const vacationTypeUpd = (data = {}) => request({ url: `/api/estate/v1/workflow/vacationTypeUpd`, method: 'post', data })

// 请假审批

export const flowVacationDetailPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowVacationDetailPage`, method: 'post', data })

export const flowVacationDetailCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowVacationDetailCount`, method: 'post', data })

export const flowApplyAudit = (data = {}) => request({ url: `/api/estate/v1/workflow/flowApplyAudit`, method: 'post', data })

export const flowApplyVacationInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/flowApplyVacationInfo`, method: 'post', data })

// 操作日志
export const operationLogPage = (data = {}) => request({ url: `/api/estate/v1/system/operationLogPage`, method: 'post', data })

export const operationLogCount = (data = {}) => request({ url: `/api/estate/v1/system/operationLogCount`, method: 'post', data })

// 出差审批
export const flowApplyTravelInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/flowApplyTravelInfo`, method: 'post', data })

export const flowTravelDetailPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowTravelDetailPage`, method: 'post', data })

export const flowTravelDetailCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowTravelDetailCount`, method: 'post', data })

// 员工考评
export const evaluationPage = (data = {}) => request({ url: `/api/estate/v1/oa/evaluationPage`, method: 'post', data })

export const evaluationCount = (data = {}) => request({ url: `/api/estate/v1/oa/evaluationCount`, method: 'post', data })

export const evaluationInfo = (data = {}) => request({ url: `/api/estate/v1/oa/evaluationInfo`, method: 'post', data })

// 考评规则
export const evaluationRulePage = (data = {}) => request({ url: `/api/estate/v1/oa/evaluationRulePage`, method: 'post', data })

export const evaluationRuleCount = (data = {}) => request({ url: `/api/estate/v1/oa/evaluationRuleCount`, method: 'post', data })

export const evaluationRuleUpd = (data = {}) => request({ url: `/api/estate/v1/oa/evaluationRuleUpd`, method: 'post', data })

export const evaluationRuleInfo = (data = {}) => request({ url: `/api/estate/v1/oa/evaluationRuleInfo`, method: 'post', data })

// 用章审批
export const flowUseSealPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowUseSealPage`, method: 'post', data })

export const flowUseSealCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowUseSealCount`, method: 'post', data })

export const flowUseSealInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/flowUseSealInfo`, method: 'post', data })

// 项目(街道)
export const streetCommunityRelPage = (data = {}) => request({ url: `/api/uc/v1/street/streetCommunityRelPage`, method: 'post', data })

export const streetCommunityRelCount = (data = {}) => request({ url: `/api/uc/v1/street/streetCommunityRelCount`, method: 'post', data })

export const batchPopulationImgDownLoad = (data = {}) =>
  request({ url: `/api/uc/v1/street/batchPopulationImgDownLoad`, method: 'post', data, responseType: 'blob', timeout: 70_000 })

// 已完成
export const staffProbationRecordIns = (data = {}) => request({ url: `/api/estate/v1/oa/staffProbationRecordIns`, method: 'post', data })

export const staffTransferRecordIns = (data = {}) => request({ url: `/api/estate/v1/oa/staffTransferRecordIns`, method: 'post', data })

export const staffInfoHandover = (data = {}) => request({ url: `/api/estate/v1/oa/staffInfoHandover`, method: 'post', data })

export const staffDimissionRecordIns = (data = {}) => request({ url: `/api/estate/v1/oa/staffDimissionRecordIns`, method: 'post', data })

export const staffProbationRecordPage = (data = {}) => request({ url: `/api/estate/v1/oa/staffProbationRecordPage`, method: 'post', data })

export const staffProbationRecordCount = (data = {}) => request({ url: `/api/estate/v1/oa/staffProbationRecordCount`, method: 'post', data })

export const staffDimissionRecordPage = (data = {}) => request({ url: `/api/estate/v1/oa/staffDimissionRecordPage`, method: 'post', data })

export const staffDimissionRecordCount = (data = {}) => request({ url: `/api/estate/v1/oa/staffDimissionRecordCount`, method: 'post', data })

//保安服务列表
export const securityServicesPage = (data = {}) => request({ url: `/api/estate/v1/quality/securityServicesPage`, method: 'post', data })

export const securityServicesCount = (data = {}) => request({ url: `/api/estate/v1/quality/securityServicesCount`, method: 'post', data })

//保洁服务列表
export const cleaningServicesPage = (data = {}) => request({ url: `/api/estate/v1/quality/cleaningServicesPage`, method: 'post', data })

export const cleaningServicesCount = (data = {}) => request({ url: `/api/estate/v1/quality/cleaningServicesCount`, method: 'post', data })

//保修服务
export const warrantyServicesPage = (data = {}) => request({ url: `/api/estate/v1/quality/warrantyServicesPage`, method: 'post', data })

export const warrantyServicesCount = (data = {}) => request({ url: `/api/estate/v1/quality/warrantyServicesCount`, method: 'post', data })

//保绿服务
export const greenServicesPage = (data = {}) => request({ url: `/api/estate/v1/quality/greenServicesPage`, method: 'post', data })

export const greenServicesCount = (data = {}) => request({ url: `/api/estate/v1/quality/greenServicesCount`, method: 'post', data })

//业主服务
export const ownerServicesPage = (data = {}) => request({ url: `/api/estate/v1/quality/ownerServicesPage`, method: 'post', data })

//品质巡查列表
export const qualityInspectionPage = (data = {}) => request({ url: `/api/estate/v1/quality/qualityInspectionPage`, method: 'post', data })

export const qualityInspectionCount = (data = {}) => request({ url: `/api/estate/v1/quality/qualityInspectionCount`, method: 'post', data })

//品质新增
export const qualityInspectionIns = (data = {}) => request({ url: `/api/estate/v1/quality/qualityInspectionIns`, method: 'post', data })

//品质巡查详情
export const qualityInspectionDetail = (data = {}) => request({ url: `/api/estate/v1/quality/qualityInspectionDetail`, method: 'post', data })

//品质巡查修改
export const qualityInspectionUpd = (data = {}) => request({ url: `/api/estate/v1/quality/qualityInspectionUpd`, method: 'post', data })

//品质巡查整改新增
export const qualityInspectionRectificationIns = (data = {}) => request({ url: `/api/estate/v1/quality/qualityInspectionRectificationIns`, method: 'post', data })

//品质巡查删除
export const qualityInspectionDel = (data = {}) => request({ url: `/api/estate/v1/quality/qualityInspectionDel`, method: 'post', data })

// 员工转岗记录列表
export const staffTransferRecordPage = (data = {}) => request({ url: `/api/estate/v1/oa/staffTransferRecordPage`, method: 'post', data })

export const staffTransferRecordCount = (data = {}) => request({ url: `/api/estate/v1/oa/staffTransferRecordCount`, method: 'post', data })

//审批流-员工补卡列表
export const workFlowMendDetailPage = (data = {}) => request({ url: `/api/estate/v1/oa/workFlowMendDetailPage`, method: 'post', data })

export const workFlowMendDetailCount = (data = {}) => request({ url: `/api/estate/v1/oa/workFlowMendDetailCount`, method: 'post', data })

export const flowMendDetail = (data = {}) => request({ url: `/api/estate/v1/oa/flowMendDetail`, method: 'post', data })

// 项目管理 小区帮帮权限关联列表
export const getOwnerPermissionByCommunity = (data = {}) => request({ url: `/api/uc/v1/permission/getOwnerPermissionByCommunity`, method: 'post', data })

//项目管理 小区帮帮权限关联列表
export const getOwnerPermissionByTenant = (data = {}) => request({ url: `/api/uc/v1/permission/getOwnerPermissionByTenant`, method: 'post', data })

// 项目管理 小区帮帮权限关联新增
export const setOwnerPermissionCommunity = (data = {}) => request({ url: `/api/uc/v1/permission/setOwnerPermissionCommunity`, method: 'post', data })
